import image from '@components/common/assets/image';

import CPagingContainer from '@components/common/CPaging/containers/CPagingContainer';
import CSearchContainer from '@components/common/CSearch/containers/CSearchContainer';
import CSelectContainer from '@components/common/CSelect/containers/CSelectContainer';
import {
  PartnersCategoryListItemTypes,
  PartnersListItemTypes,
  PartnersReqCategoryTypes,
  PartnersUpdateReqCategoryTypes,
  StoreTypes,
} from '@typedef/components/Partners/partners.types';
import React from 'react';

type Props = {
  stores: StoreTypes[];
  maxPage: number;
  currentPage: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  onPageChanged: (page: number) => void;
  searchInput: string;
  onSearchInputChanged: (value: string) => void;
  onPartnersItemClicked: (item: StoreTypes) => void;
  shopCategory: PartnersCategoryListItemTypes[];
  onSearchBtnClicked: () => void;
  setSelectedCategory: React.Dispatch<
    React.SetStateAction<PartnersCategoryListItemTypes | null>
  >;
  requestCategory: PartnersUpdateReqCategoryTypes[];
  setSelectedReqCategory: React.Dispatch<React.SetStateAction<string>>;
  selectedCategory: PartnersCategoryListItemTypes | null;
  selectedReqCategory: string;
};

const UpdateRequestList = ({
  stores,
  maxPage,
  currentPage,
  setCurrentPage,
  onPageChanged,
  searchInput,
  onSearchInputChanged,
  onPartnersItemClicked,
  shopCategory,
  onSearchBtnClicked,
  setSelectedCategory,
  requestCategory,
  setSelectedReqCategory,
  selectedCategory,
  selectedReqCategory,
}: Props) => {
  return (
    <div className='partners-list-root table-container'>
      <div className='search-section'>
        <form>
          <div className='input-container'>
            <label
              htmlFor='input-partners-search'
              className='input-label'
              hidden>
              {'검색'}
            </label>
            <input
              className='input-box search'
              type='text'
              value={searchInput}
              onChange={(e) => onSearchInputChanged(e.target.value)}
              id='input-partners-search'
              placeholder={
                '아이디, 이름, 전화번호, 가게명, 사업장 주소로 검색해주세요'
              }
            />
            <button
              className='input-button'
              onClick={(e) => {
                e.preventDefault();
                onSearchBtnClicked();
              }}>
              <img src={image.searchBtn} alt='search-btn' />
            </button>
          </div>
        </form>
        <div className='select-container'>
          <label htmlFor='store-select' hidden>
            {'가게 종류'}
          </label>
          <select
            className={'select-box'}
            placeholder='가게 종류'
            name='select-store'
            id='select-store'
            value={selectedCategory?.targetTagUid}
            onChange={(e) => {
              const idx = Number(e.target.selectedOptions[0].dataset.idx);
              setCurrentPage(0);
              setSelectedCategory(shopCategory[idx]);
            }}
            style={{ background: `url(${image.selectArrow}) no-repeat 90%` }}>
            {shopCategory.map((item, idx) => {
              return (
                <option
                  key={idx}
                  data-idx={idx}
                  value={item.targetTagUid}
                  className={'option-store'}>
                  {item.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className='select-container'>
          <label htmlFor='signup-req-select' hidden>
            {'요청 종류'}
          </label>
          <select
            className={'select-box'}
            placeholder='요청 종류'
            name='select-signup-req'
            id='select-signup-req'
            value={selectedReqCategory}
            onChange={(e) => {
              setCurrentPage(0);
              setSelectedReqCategory(e.target.value);
            }}
            style={{ background: `url(${image.selectArrow}) no-repeat 90%` }}>
            {requestCategory.map((item, idx) => {
              return (
                <option
                  key={idx}
                  value={item.state}
                  className={'option-signup-req'}>
                  {item.label}
                </option>
              );
            })}
          </select>
        </div>
      </div>
      <div className='header-section'>
        <div className='item'>아이디</div>
        <div className='item'>이름</div>
        <div className='item'>전화번호</div>
        <div className='item'>가게명</div>
        <div className='item'>샵종류</div>
        <div className='item'>사업장 주소</div>
      </div>
      <div className='body-section'>
        {stores.map((item, index) => (
          <div
            key={index}
            className='row'
            onClick={() => onPartnersItemClicked(item)}>
            <div className='item'>{item.partners?.name}</div>
            <div className='item'>{item.partners?.partnersName}</div>
            <div className='item'>{item.phone}</div>
            <div className='item'>{item.name}</div>
            <div className='item'>{item.targetTag.name}</div>
            <div className='item'>{item.location}</div>
          </div>
        ))}
      </div>
      <div className='footer-section'>
        <CPagingContainer
          maxPage={maxPage}
          page={currentPage}
          setPage={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default UpdateRequestList;
